import { useMutation } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { Pixel } from '../models'

interface SetPixelsApiResponse {
  selectedPixels: Pixel[]
  invalidWritePremissionAdAccounts: string[]
}

export const setSelectedFacebookPixels = async (
  accountId: number,
  connectionId: number,
  pixelIds: number[]
): Promise<SetPixelsApiResponse | Error> => {
  return await request({
    url: `/accounts/${accountId}/facebook/${connectionId}/pixels/selected`,
    method: 'PUT',
    data: { pixelIds },
  })
}

export const useSetSelectedFacebookPixels = () => {
  const { accountId } = useUserStore()
  return useMutation({
    mutationKey: ['setSelectedFacebookPixels'],
    mutationFn: ({ connectionId, pixelIds }: { connectionId: number; pixelIds: number[] }) =>
      setSelectedFacebookPixels(accountId, connectionId, pixelIds),
  })
}
